import { useEffect, useState } from 'react';
import { Checkbox, FormControlLabel, FormGroup, FormControl } from '@mui/material';
import { styled } from '@mui/system';

const FlexFormGroup = styled(FormGroup)({
  display: 'flex',
  flexDirection: 'row', // Change to 'column' for vertical layout
});

const CustomCheckbox = ({ options, onLabelSelect, selectedLabels }: { 
  options: any; 
  onLabelSelect: (labels: string[]) => void;
  selectedLabels: any;
}) => {
  const [selected, setSelected] = useState<string[]>(selectedLabels || []);

  useEffect(() => {
    if (options.length > 0 && selected.length === 0) {
      const initialSelection = options.map((option: any) => option.label);
      setSelected(initialSelection);
      onLabelSelect(initialSelection);
    }
  }, [options, onLabelSelect, selected.length]);

  const handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const label = event.target.value;
    const isChecked = event.target.checked;

    let updatedSelection;
    if (isChecked) {
      updatedSelection = [...selected, label];
    } else {
      updatedSelection = selected.filter((item) => item !== label);
    }

    setSelected(updatedSelection);
    onLabelSelect(updatedSelection); // Call the callback function to return the selected labels
  };

  return (
    <FormControl component="fieldset">
      <FlexFormGroup>
        {options.map((option: any, index: any) => (
          <FormControlLabel
            key={index}
            control={
              <Checkbox 
                checked={selected.includes(option.label)} 
                onChange={handleCheckboxChange} 
                value={option.label} 
              />
            }
            label={option.label} // This is the label that will be displayed
          />
        ))}
      </FlexFormGroup>
    </FormControl>
  );
};

export default CustomCheckbox;
